/**
 * CalculateApplicationContainer
 * --
 *
 */

import React from 'react';
import { useUserStack } from 'store';
import CalculateApplication from 'routes/admin.routes/admin.calculate/CalculateApplication';

/**----------------------------------------
 * [Component] 쇼핑몰관리자: 출금목록 컨테이너
 * ----------------------------------------
 */
const CalculateApplicationContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();

  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <CalculateApplication
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default CalculateApplicationContainer;
